























































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  AlertMessage,
  defaultReserveContactInfo,
  defaultSimpleBibliographyReal,
  defaultSystemCode,
  ErrorMessage,
  reserveApi,
  ReserveContactInfo,
  SimpleBibliographyReal
} from '@/api'
import {
  alertStore,
  modalErrorStore,
  systemCodeStore
} from '@/utils/store-accessor'
import {
  InputOfReserveContactSituationUserInfo,
  InputOfReserveContactSituationUserInfoItem,
  defaultInputOfReserveContactSituationUserInfoItem
} from '@/components/organisms/InputOfReserveContactSituationUserInfo'
import {
  InputOfReserveContactSituationBibliographyInfo,
  InputOfReserveContactSituationBibliographyInfoItem,
  defaultInputOfReserveContactSituationBibliographyInfoItem
} from '@/components/organisms/InputOfReserveContactSituationBibliographyInfo'
import {
  InputOfReserveContactSituationCollectionInfo,
  InputOfReserveContactSituationCollectionInfoItem,
  defaultInputOfReserveContactSituationCollectionInfoItem
} from '@/components/organisms/InputOfReserveContactSituationCollectionInfo'
import {
  InputOfReserveContactSituationReserveInfo,
  InputOfReserveContactSituationReserveInfoItem,
  defaultInputOfReserveContactSituationReserveInfoItem
} from '@/components/organisms/InputOfReserveContactSituationReserveInfo'
import {
  InputOfReserveContactSituationReserveContactInfo,
  InputOfReserveContactSituationReserveContactInfoItem,
  defaultInputOfReserveContactSituationReserveContactInfoItem
} from '@/components/organisms/InputOfReserveContactSituationReserveContactInfo'
import { CODE_KEY } from '@/config'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import { AlertCodeAL600004, AlertCodeALC00012, SearchType } from '@/types'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import { setErrorMessage } from '@/utils/error'

interface ModalInputOfReserveContactSituationInterface {
  reserveId: number
  onUpdated: () => void
}

interface ModalInputOfReserveContactSituationItem {
  dialog: boolean
  reserveId: number
  isUpdated: boolean
  fetchedInfo: ReserveContactInfo
  userInfo: InputOfReserveContactSituationUserInfoItem
  simpleBibliographyReal: SimpleBibliographyReal
  bibliographyInfo: InputOfReserveContactSituationBibliographyInfoItem
  collectionInfo: InputOfReserveContactSituationCollectionInfoItem
  reserveInfo: InputOfReserveContactSituationReserveInfoItem
  reserveContactInfo: InputOfReserveContactSituationReserveContactInfoItem
  onUpdated: () => void
}

const defaultModalInputOfReserveContactSituationItem = (): ModalInputOfReserveContactSituationItem => ({
  dialog: false,
  reserveId: 0,
  isUpdated: false,
  fetchedInfo: defaultReserveContactInfo(),
  userInfo: defaultInputOfReserveContactSituationUserInfoItem(),
  simpleBibliographyReal: defaultSimpleBibliographyReal(),
  bibliographyInfo: defaultInputOfReserveContactSituationBibliographyInfoItem(),
  collectionInfo: defaultInputOfReserveContactSituationCollectionInfoItem(),
  reserveInfo: defaultInputOfReserveContactSituationReserveInfoItem(),
  reserveContactInfo: defaultInputOfReserveContactSituationReserveContactInfoItem(),
  onUpdated: () => {}
})

@Component({
  components: {
    BibliographyRealInfoMagazine,
    InputOfReserveContactSituationReserveContactInfo,
    InputOfReserveContactSituationReserveInfo,
    InputOfReserveContactSituationCollectionInfo,
    InputOfReserveContactSituationBibliographyInfo,
    InputOfReserveContactSituationUserInfo,
    ModalFooter
  }
})
export default class ModalInputOfReserveContactSituation extends ComponentVue {
  item: ModalInputOfReserveContactSituationItem = defaultModalInputOfReserveContactSituationItem()

  get isMagazine(): boolean {
    return (
      this.item.simpleBibliographyReal.searchType.code === SearchType.Magazine
    )
  }

  get hasReserveExpiration(): boolean {
    return this.item.fetchedInfo.reserve.reserveExpiration !== ''
  }

  onClickIconOfReserveExpiration(): void {
    if (this.hasReserveExpiration) {
      this.deleteReserveExpiration()
      return
    }

    this.updateReserveExpiration()
  }

  onClickOk(): void {
    const update = () => {
      if (
        this.item.fetchedInfo.reserve.reserveContactCompleted &&
        !this.item.reserveContactInfo.reserveContactComplete.input
      ) {
        alertStore.setItem(
          AlertFactory.create(AlertCodeALC00012, '最終連絡日と連絡回数の初期化')
        )
        this.$modalAlert.open({
          isUseOk: false,
          addButtons: [
            {
              label: '初期化しないで更新',
              onClick: () => {
                this.$modalAlert.close()
                this.updateReserveContact(false)
              }
            },
            {
              label: '初期化して更新',
              primary: true,
              onClick: () => {
                this.$modalAlert.close()
                this.updateReserveContact(true)
              }
            }
          ]
        })
        return
      }

      this.updateReserveContact(false)
    }

    if (this.item.reserveContactInfo.reserveExpiration.input === '') {
      alertStore.setItem(AlertFactory.create(AlertCodeAL600004, '受取待期限日'))
      this.$modalAlert.open({ onOkClick: () => setTimeout(update, 100) })
      return
    }

    update()
  }

  onClickPrint(): void {
    const element = document.getElementById(
      'modal-input-of-reserve-contact-situation'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  open(params: ModalInputOfReserveContactSituationInterface): void {
    this.item.dialog = true
    this.item.reserveId = params.reserveId
    this.item.onUpdated = params.onUpdated
    systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.RESERVE_NOTE.KEY])

    this.getReserveContactInfo()
  }

  close(): void {
    if (this.item.isUpdated) {
      this.item.onUpdated()
    }

    this.item = defaultModalInputOfReserveContactSituationItem()
  }

  getReserveContactInfo(): void {
    this.getReserveContactInfoInterface(false)
  }

  reconfigureReserveContactInfo(): void {
    this.getReserveContactInfoInterface(true)
  }

  async getReserveContactInfoInterface(isReconfigure: boolean): Promise<void> {
    try {
      const response: ReserveContactInfo = await reserveApi.getReserveContactInfo(
        this.item.reserveId
      )

      this.item.fetchedInfo = response
      this.item.userInfo = {
        userId: response.user.id,
        name: response.user.name,
        nameKana: response.user.nameKana,
        phoneNumber: response.user.phoneNumber,
        phoneType: response.user.phoneType,
        reserveContactTime: response.reserve.reserveContactTime,
        userType: response.user.userType,
        reserveContactCount: response.reserve.reserveContactCount
      }
      this.item.simpleBibliographyReal = {
        bibliographyClass: response.bibliography.bibliographyClass,
        prefix: response.bibliography.prefix,
        bibliographyId: response.bibliography.bibliographyId,
        searchType: response.bibliography.searchType,
        displayMaterialFormat: response.bibliography.displayMaterialFormat,
        displayClass: response.bibliography.displayClass,
        displayTitle: response.bibliography.displayTitle,
        displaySubtitle: '',
        displayAuthor: response.bibliography.displayAuthor,
        volume: response.bibliography.volume,
        volumeNumber: response.bibliography.volumeNumber,
        volumeTotal: response.bibliography.volumeTotal,
        volumeDateLabel: response.bibliography.volumeDateLabel,
        volumeSpecial: response.bibliography.volumeSpecial,
        displayPublisher: response.bibliography.displayPublisher,
        displayPublished: '',
        displaySize: '',
        bibliographySetId: response.bibliography.bibliographySetId,
        marcType: defaultSystemCode(),
        marcNo: '',
        holdingCount: response.bibliography.holdingCount,
        orderCount: response.bibliography.orderCount,
        reserveCount: response.bibliography.reserveCount,
        collectionFlag: response.bibliography.collectionFlag,
        isbn10: '',
        isbn13: ''
      }
      this.item.bibliographyInfo = {
        displayMaterialFormat: response.bibliography.displayMaterialFormat,
        displayClass: response.bibliography.displayClass,
        prefix: response.bibliography.prefix,
        searchType: response.bibliography.searchType,
        displayTitle: response.bibliography.displayTitle,
        collectionFlag: response.bibliography.collectionFlag,
        displayAuthor: response.bibliography.displayAuthor,
        displayPublisher: response.bibliography.displayPublisher,
        bibliographyId: response.bibliography.bibliographyId
      }
      this.item.collectionInfo = {
        collectionNo: response.collection.collectionNo,
        holdingBranchCode: response.collection.holdingBranchCode,
        callNumber: response.collection.callNumber,
        shelfType: response.collection.shelfType,
        collectionType: response.collection.collectionType,
        status: response.collection.status,
        handlingType: response.collection.handlingType,
        appendixCode: response.collection.appendixCode,
        updatedTime: response.collection.updatedTime,
        updatedBranchCode: response.collection.updatedBranchCode
      }
      this.item.reserveInfo = {
        contactMethod: response.reserve.contactMethod,
        registrationBranchCode: response.reserve.registrationBranchCode,
        registrationTime: response.reserve.registrationTime,
        reserveNoticeAllowed: response.reserve.reserveNoticeAllowed,
        registrationPlaceCode: response.reserve.registrationPlaceCode,
        preferredDate: response.reserve.preferredDate,
        forwardingBranchCode: response.reserve.forwardingBranchCode,
        forwardingPlaceCode: response.reserve.forwardingPlaceCode
      }

      if (isReconfigure) {
        this.item.reserveContactInfo.hasReserveExpiration =
          response.reserve.reserveExpiration !== ''
        this.item.reserveContactInfo.reserveExpiration.input =
          response.reserve.reserveExpiration
      } else {
        this.item.reserveContactInfo = {
          reserveContactComplete: {
            input: response.reserve.reserveContactCompleted
          },
          hasReserveExpiration: response.reserve.reserveExpiration !== '',
          reserveExpiration: {
            input: response.reserve.reserveExpiration,
            errorMessage: ''
          },
          displayMemo: {
            input: '',
            errorMessage: '',
            text: response.reserve.displayMemo
          }
        }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: this.close
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open({
          onOkClick: this.close
        })
      } else {
        console.error(error)
      }
    }
  }

  async updateReserveContact(
    _isClearReserveContactInfo: boolean
  ): Promise<void> {
    try {
      await reserveApi.updateReserveContact({
        id: this.item.fetchedInfo.reserve.id,
        revision: this.item.fetchedInfo.reserve.revision,
        reserveContactComplete: this.item.reserveContactInfo
          .reserveContactComplete.input,
        reserveExpiration: this.item.reserveContactInfo.reserveExpiration.input,
        displayMemo: this.item.reserveContactInfo.displayMemo.text,
        _isClearReserveContactInfo
      })

      this.item.isUpdated = true
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          reserveExpiration: this.item.reserveContactInfo.reserveExpiration,
          displayMemo: this.item.reserveContactInfo.displayMemo
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async updateReserveExpiration(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.updateReserveExpiration({
        id: this.item.fetchedInfo.reserve.id,
        revision: this.item.fetchedInfo.reserve.revision
      })

      await this.reconfigureReserveContactInfo()
      this.item.isUpdated = true
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async deleteReserveExpiration(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.deleteReserveExpiration({
        id: this.item.fetchedInfo.reserve.id,
        revision: this.item.fetchedInfo.reserve.revision
      })

      await this.reconfigureReserveContactInfo()
      this.item.isUpdated = true
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
